import React from 'react';
import { ButtonProps } from 'antd/lib/button';
import CcCluster from '../../services/models/CcCluster';
import { CmonJobInstanceCommand } from '../../services/cmon/models/CmonJobInstance';
import JobCreateActionButton from '../Jobs/JobCreateActionButton';

export default DisableAuditLogButton;

export type DisableAuditLogButtonProps = ButtonProps & {
    cluster: CcCluster;
    onSuccess?: () => void;
};

function DisableAuditLogButton({
    cluster,
    onSuccess,
    ...rest
}: DisableAuditLogButtonProps) {
    return (
        <JobCreateActionButton
            clusterId={cluster.clusterId}
            command={
                CmonJobInstanceCommand.SETUP_AUDIT_LOGGING.toLowerCase() as CmonJobInstanceCommand
            }
            jobData={{
                action: 'disable',
                clusterId: `${cluster.clusterId}`,
            }}
            confirmTitle={'Are you sure you want to disable audit logging?'}
            title={'Audit logging'}
            okText={'Disable'}
            onSuccess={onSuccess}
            switchValue={true}
            {...rest}
        />
    );
}
